import api from './api';
import { RecurringInvoice, Invoice } from '../types';

export const recurringInvoiceService = {
  getAll: async (includeInactive = false): Promise<RecurringInvoice[]> => {
    const response = await api.get('/recurring-invoices', { params: { includeInactive } });
    return response.data;
  },

  getById: async (id: number): Promise<RecurringInvoice> => {
    const response = await api.get(`/recurring-invoices/${id}`);
    return response.data;
  },

  create: async (data: RecurringInvoice): Promise<RecurringInvoice> => {
    const response = await api.post('/recurring-invoices', data);
    return response.data;
  },

  update: async (id: number, data: RecurringInvoice): Promise<RecurringInvoice> => {
    const response = await api.put(`/recurring-invoices/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/recurring-invoices/${id}`);
  },

  /** Legt aus einer bestehenden Rechnung eine Serie an. */
  createFromInvoice: async (invoiceId: number): Promise<RecurringInvoice> => {
    const response = await api.post(`/recurring-invoices/from-invoice/${invoiceId}`);
    return response.data;
  },

  /** Löst den fälligen Lauf sofort aus: erzeugt, schreibt fest und verschickt. */
  run: async (id: number): Promise<Invoice> => {
    const response = await api.post(`/recurring-invoices/${id}/run`);
    return response.data;
  },
};

export default recurringInvoiceService;
